"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const nmr_processing_1 = require("nmr-processing");
const DispatchContext_1 = require("../../../context/DispatchContext");
const EditableColumn_1 = __importDefault(require("../../../elements/EditableColumn"));
const formatNumber_1 = require("../../../utility/formatNumber");
function SignalDeltaColumn({ row, onHover, format, rowSpanTags, }) {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const signal = row.tableMetaInfo.signal;
    function saveHandler(event) {
        dispatch({
            type: 'CHANGE_RANGE_SIGNAL_VALUE',
            payload: {
                value: event.target.value,
                rangeID: row.id,
                signalID: signal.id,
            },
        });
    }
    if (!signal)
        return (0, jsx_runtime_1.jsx)("td", { children: '' });
    return ((0, jsx_runtime_1.jsx)("td", { ...rowSpanTags, ...onHover, children: !(0, nmr_processing_1.checkMultiplicity)(signal.multiplicity, ['m']) ? (`${(0, formatNumber_1.formatNumber)(row.from, format)} - ${(0, formatNumber_1.formatNumber)(row.to, format)}`) : ((0, jsx_runtime_1.jsx)(EditableColumn_1.default, { value: (0, formatNumber_1.formatNumber)(signal.delta, format), onSave: saveHandler, type: "number", style: { padding: '0.1rem 0.4rem' }, validate: (val) => val !== '' })) }));
}
exports.default = SignalDeltaColumn;
